import request from '@/utils/request'

export function recalcLeadCost(leadId, periodMonth) {
  return request({
    url: `/api/finance/lead-cost/${leadId}`,
    method: 'post',
    params: { periodMonth }
  })
}

export function recalcLeadCostMonth(periodMonth) {
  return request({
    url: '/api/finance/lead-cost/recalc-month',
    method: 'post',
    params: { periodMonth }
  })
}

export function fetchLeadCostMonthPage(params) {
  return request({
    url: '/api/finance/lead-cost/month',
    method: 'get',
    params
  })
}
